import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBarChartDetails, getLabelDetails
} from "../../apiService/barChart";

export const getBarChartData = createAsyncThunk(
  "vyga/getCollectionDetails",
  async (collectionId: string | undefined, { rejectWithValue }) => {
    try {
      const result = await getBarChartDetails(collectionId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getLabelData = createAsyncThunk(
  "vyga/getCollectionDetails",
  async (_ ,{ rejectWithValue }) => {
    try {
      const result = await getLabelDetails();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
